module.exports = "https://static.energy5.com/_next/static/images/evBg-a0d556360bd3cd40c6cf35daf373a32d.webp";